import Demographic from "./Demographic";

export default Demographic;